import { Component, Host, h, Prop, State, Element } from '@stencil/core';
import mobile from '../../assets/svg/iphone.svg';
import whatsapp from '../../assets/svg/whatsapp2.svg';
import phone from '../../assets/svg/phone.svg';
import telegram from '../../assets/svg/paper-plane-o.svg';
import email from '../../assets/svg/mail.svg';
/**
 * @slot contact - Replaces contact item, has replaceable props `{icon}`, `{value}`.
 */
@Component({
  tag: 'salla-contacts',
  styleUrl: 'salla-contacts.scss',
})
export class SallaContacts {
  constructor() {
    this.contactSlot = this.host.querySelector('[slot="contact"]')?.innerHTML || `<a href={link} class="s-contacts-item"><span class="s-contacts-icon">{icon}</span>${!this.iconsOnly && "<span class='unicode'>{value}</span>"}</a>`;

    salla.onReady(() => {
      this.contacts = salla.config.get('store.contacts');
    });

    salla.lang.onLoaded(() => {
      this.contactsTitle =  this.contactsTitle || salla.lang.get('blocks.footer.social');
    });
  }
  private readonly contactSlot: string;

  /**
   * Section title for social block of footer.
   */
  @Prop({mutable: true}) contactsTitle: string;

  /**
   * Flag to toggle title visibility.
   */
  @Prop() hideTitle: boolean;

  /**
   * Conditional flag to check whether the content is header or not.
   */
  @Prop() isHeader: boolean;

  /**
   * Flag to toggle list of contents whether vertical or horizontal.
   */
  @Prop() horizontal: boolean;

  /**
   * Flag condition to show icon only or icon with label
   */
  @Prop() iconsOnly: boolean;


  @Element() host: HTMLElement;
  @State() contacts: any = salla.config.get('store.contacts');
  @State() iconsList: any = { mobile, whatsapp, phone, telegram, email }
  private getContactsArray() {
    return Object.entries(this.contacts)
      .filter(([_key, value]) => value !== '')
      .map(([type, value]) => ({ type, value }));
  }

  private getContactLink(type) {
    const contactValue = this.contacts[type];
    switch (type) {
      case 'phone':
      case 'mobile':
        return `tel:${contactValue}`;
      case 'whatsapp':
        return salla.url.get('whatsapp/send');
      case 'email':
        return `mailto:${contactValue}`;
      case 'telegram':
        // Check if the contact is already a full URL
        return contactValue.startsWith('https://t.me/') ? contactValue : `https://t.me/${contactValue}`;
      default:
        return contactValue;
    }
  }
  private getContactIcon(type) {
    return this.iconsList[type];
  }

  componentWillLoad() {
    return new Promise(resolve => salla.onReady(resolve));
  }


  render() {
    const contactsArray = this.getContactsArray();
    if (this.isHeader && contactsArray && contactsArray.length > 0) {
      return (
        <Host class="s-contacts s-contacts-header">
          {contactsArray.filter((contact) => contact.type == 'phone' || contact.type == 'email').map((contact, index) => (
            <a href={this.getContactLink(contact.type)} key={index} class="s-contacts-topnav-link">
              {contact.type === 'email' ? (
                contact.value
              ) : (
                [
                  <span>{this.contactsTitle}: </span>,
                  <a class="unicode" href={this.iconsList[contact.type]}>{contact.value}</a>
                ]
              )}
            </a>
          ))}
        </Host>
      );
    }
    return (
      <Host class="s-contacts">
        {!this.hideTitle && <h3 class="s-contacts-title">{this.contactsTitle}</h3>}
        <div class={{
          's-contacts-list': true,
          's-contacts-list-horizontal': this.horizontal,
          's-contacts-list-vertical': !this.horizontal,
          's-contacts-list-icons-only': this.iconsOnly
        }
        }>
          {contactsArray.map((contact, index) => (
            <div key={index} id="contact-slot" innerHTML={this.contactSlot
              .replace(/\{icon\}/g, this.getContactIcon(contact.type))
              .replace(/\{value\}/g, contact.value.toString())
              .replace(/\{link\}/g, this.getContactLink(contact.type))}>
            </div>
          ))}
        </div>
      </Host>
    );
  }
  componentDidRender() {
    // this.host.querySelectorAll('#contact-slot').forEach(el => el.replaceWith(el.firstChild));
    this.host.querySelector('[slot="contact"]')?.remove();
  }
}

